export enum ChipActionType {
    ADD,
    DOUBLE,
    MOVE,
    REMOVE,
    REPEAT,
    SECTOR_CHOICE,
}

export enum ChipValidationState {
    ERROR,
    HIGHLIGHTED,
}

export enum CasinoAutoPlayEndReason {
    DEFAULT,
    ROUNDS_FINISHED,
    PENDING_START,
}
